<template>
  <div class="contact-info">
    <v-card
      class="mx-auto fixed-header"
    >
      <v-app-bar
        dark
        class="fixed-header"
        style="background-color: #ffffff;color:black"
      >
        <div style="margin-left: 25px;" >
          <img :src="get_user_image()" class="circle-img"/>
        </div>
        <v-toolbar-title>
        <span class="router-name">
          {{$route.meta.name}}
        </span>
        </v-toolbar-title>

        <v-spacer></v-spacer>

        <v-btn style="left:0;position: absolute" v-on:click="go_back()" v-if='$route.meta.name != "خانه"' icon>
          <!--        <v-icon color="black" >mdi-chevron-left</v-icon>-->
          <img src="/img/back_icon.svg" style="    width: 30px;
    height: 30px;
    padding: 6px;"/>
        </v-btn>
      </v-app-bar>

    </v-card>
    <div class="picture-part" style="margin-top: 80px;position: relative">
      <div class="img-width" style="text-align: center">
        <v-dialog
          v-model="dialog2"
          fullscreen
          hide-overlay
          transition="dialog-bottom-transition"
          width="100%"
        >
          <template v-slot:activator="{ on, attrs }">
            <button
              class="btn open-image-btn"
              v-bind="attrs"
              v-on="on"
            >
              <img :src="user_info.ThumbPath"/>

            </button>
          </template>

          <v-card class="edit-picture blue-border">
            <v-toolbar
              dark
              color="primary"
            >
              <v-btn
                icon
                dark
                @click="dialog2 = false"
              >
                <v-icon>mdi-close</v-icon>
              </v-btn>
              <!--                <v-toolbar-title>گالری</v-toolbar-title>-->
              <v-spacer></v-spacer>

            </v-toolbar>

            <v-card-text>

              <VueSlickCarousel :arrows="true" :dots="false">
                <div v-for="item in photos" class="full-screen-photos">
                  <img :src="item.ImageUrl"/>

                </div>

              </VueSlickCarousel>
            </v-card-text>

          </v-card>
        </v-dialog>
      </div>

      <div style="position: absolute;
    bottom: 10px;
    left: 20px;">
        <div v-on:click="goToDetail()">
          <img style="width: 50px" src="/img/chat_icon.svg"/>
        </div>

      </div>
    </div>

    <div class="user-code">
      <div v-if="group_flag == false">
        {{ user_info.Name }}
      </div>
      <div v-if="group_flag == true">
        {{ user_info.GroupName }}
        <v-icon @click="edit_group_dialog=true">mdi-pencil</v-icon>
      </div>
    </div>
    <div class="user-code">
      <label v-if="group_flag == false">
        شناسه کاربری
      </label>
      <p v-if="group_flag == false">
        {{ user_info.UserCode}}
      </p>
      <label v-if="group_flag == true">
        شناسه گروه
      </label>
      <p v-if="group_flag == true">
        {{ user_info.GroupCode}}
      </p>
      <div v-if="group_flag == true">
        <v-btn color="primary" @click="dialog_add_user=true">
          افزودن شخص به گروه
        </v-btn>
      </div>
    </div>

    <v-dialog class="" v-model="edit_group_dialog" persistent>
      <v-card class="dialog1-card">
        <div class="text-center dialog-header">
          <span class="name">
            ویرایش گروه
          </span>
          <span class="back-btn" @click="edit_group_dialog = false">
               <v-icon>
                mdi-arrow-left
              </v-icon>
          </span>
        </div>
        <v-card-text>
          <v-container>

<v-text-field
  v-model="user_info.GroupName"
  />
          </v-container>
        </v-card-text>
        <v-btn color="primary" style="width: 100%" v-on:click="edit_group()">
          ویرایش
        </v-btn>
      </v-card>
    </v-dialog>

    <v-dialog class="" v-model="dialog_add_user" persistent>
      <v-card class="dialog1-card" style="height: 90vh">
        <div class="text-center dialog-header">
          <span class="name">
            افزودن کاربر
          </span>
          <span class="back-btn" @click="dialog_add_user = false">
               <v-icon>
                mdi-arrow-left
              </v-icon>
          </span>
        </div>
        <v-card-text style="overflow: auto;
    height: 77vh;">
          <v-container>

            <div class="select-contact">
              <div class="contact-preview" v-for="(item , i) in contacts" v-bind:key="item.UserContactId"
                   v-on:click="select_contact(i)" v-bind:class="{'is-select': item.IsSelected} ">
                <div class="row">
                  <div class="col-2 no-padding-l">
                    <img :src="item.ImageUrl"/>
                  </div>
                  <div class="col-6">
          <span class="contact-username">
            {{ item.UserName }}
          </span>
                  </div>
                  <div class="col-4">
          <span class="contact-code">
            {{ item.UserCode }}
          </span>
                  </div>
                </div>
              </div>

            </div>

          </v-container>
        </v-card-text>
        <v-btn color="primary" style="width: 100%" v-on:click="addGroupPreDefined()">
          افزودن
        </v-btn>
      </v-card>
    </v-dialog>

  </div>
</template>

<script>

  import VueSlickCarousel from 'vue-slick-carousel'
  import 'vue-slick-carousel/dist/vue-slick-carousel.css'
  import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'
  import {bus} from '../../main'

  export default {
    data() {
      return {
        edit_group_dialog: false,
        dialog_add_user: false,
        contacts: [],
        selectedContactItem: [],
        user_info: '',
        items: '',
        lastItemId: 0,
        lastLogId: 0,
        switch1: true,
        dialog2: false,
        photos: '',
        UserId: '',
        group_flag: false,
        silent_list: [],
      }
    },
    components: {VueSlickCarousel},
    watch: {},
    mounted() {
      var user_data = JSON.parse(localStorage.getItem('zoodpayam_profile'))

      this.UserId = user_data.UserId
      this.items = JSON.parse(localStorage.getItem('lastChat'))
      // console.log("lastChat", this.items)
      if (this.items.RecType == 0) {
        this.getUserInfo()
        this.group_flag = false
      } else {
        this.getGroupInfo()
        this.group_flag = true
      }
      this.GetUserImages()
      // this.getUserInfo();
      // localStorage.getItem("LastUserInfo")
    },

    methods: {
      go_back() {
        localStorage.setItem('LastUserInfo', null)
        if (!this.get_ismobile()) {
          bus.$emit('contact_chat_info_update', true)
        } else {
          this.$router.go(-1)
        }
      },
      getAllContacts() {
        this.phone = localStorage.getItem('zoodpayam_phone')
        this.password = localStorage.getItem('zoodpayam_password')
        const send_data = {
          Phone: this.phone,
          Password: this.password,
          LastItemId: this.lastItemId,
          LastLogId: this.lastLogId
        }
        var self = this
        this.axios.post('/ShowAllGroupContacts', send_data, {})
          .then(response => {
            if (response.data.error == 0) {
              this.contacts = response.data.contacts
              for (var i = 0; i < this.contacts.length; i++) {
                this.contacts[i].IsSelected = false
              }
            }
          }).catch(e => {

        })
      },

      goToDetail(item) {
        // console.log("iteem", )
        const last_chat_detail = {
          RecType: this.items.RecType,
          UserOrGroupId: this.items.UserOrGroupId,
        }
        localStorage.setItem('lastChat', JSON.stringify(last_chat_detail))
        this.$router.push({name: 'مکالمه', params: {}})
      },
      GetUserImages() {
        const send_data = {
          UserId: this.items.UserOrGroupId,
          RecType: this.items.RecType,
        }
        var self = this
        this.axios.post('/GetUserImages', send_data, {})
          .then(response => {
            if (response.data.error == 0) {
              console.log('user info', response.data.imgs)
              self.photos = response.data.imgs
              // self.user_info = response.data.userInfo;
            }
          }).catch(e => {

        })
      },
      addGroupPreDefined() {
        var selected_contacts = this.contacts.filter(x => x.IsSelected)
        if (selected_contacts.length == 0) {

        } else {
          for (var i = 0; i < selected_contacts.length; i++) {
            this.addGroup(selected_contacts[i])
          }
        }
      },
      addGroup(item) {
        this.phone = localStorage.getItem('zoodpayam_phone')
        this.password = localStorage.getItem('zoodpayam_password')
        const send_data = {
          GroupId: this.items.UserOrGroupId,
          Phone: this.phone,
          Password: this.password,
          MemberId: item.ContactId,
          MemberName: item.UserName,
        }

        var self = this
        self.dialog_add_user = false

        this.axios.post('/AddGroupMember', send_data, {})
          .then(response => {
            bus.$emit('show_toast', [2000, response.data.msg])

            if (response.data.error == 0) {
              console.log('user info', response.data.imgs)
            }
          }).catch(e => {

        })
      },
      edit_group() {
        var self = this

        this.phone = localStorage.getItem('zoodpayam_phone')
        this.password = localStorage.getItem('zoodpayam_password')
        var user_data = JSON.parse(localStorage.getItem('zoodpayam_profile'))
        const send_data = {
          GroupId: this.items.UserOrGroupId,
          Password: this.password,
          UserId:user_data.UserId,
          GroupName:self.user_info.GroupName,
          GroupCode:self.user_info.GroupCode,
        }

        self.edit_group_dialog = false

        this.axios.post('/EditGroup', send_data, {})
          .then(response => {
            bus.$emit('show_toast', [2000, response.data.msg])

            if (response.data.error == 0) {
self.getGroupInfo();
            }
          }).catch(e => {

        })
      },
      getGroupInfo() {
        console.log('get group info')
        const send_data = {
          UserId: this.UserId,
          GroupId: this.items.UserOrGroupId
        }
        var self = this
        this.axios.post('/GetGroupInfo', send_data, {})
          .then(response => {
            if (response.data.error == 0) {
              // console.log("user info" , response.data.userInfo)
              self.user_info = response.data.userInfo
              self.getAllContacts()
            }
          }).catch(e => {

        })
      },
      getUserInfo() {
        const send_data = {
          UserId: this.items.UserOrGroupId
        }
        var self = this
        this.axios.post('/GetUserInfo', send_data, {})
          .then(response => {
            if (response.data.error == 0) {
              console.log('user info', response.data.userInfo)
              self.user_info = response.data.userInfo
            }
          }).catch(e => {

        })
      },
      select_contact(i) {
        this.selectedItem = []
        var data = this.contacts[i]
        if (data.IsSelected == true) {
          data.IsSelected = false
          this.contacts.splice(i, 1, data) // replace it
        } else {
          data.IsSelected = true
          this.contacts.splice(i, 1, data) // replace it
          // this.selectedItem.push(this.items[i]);
        }
        for (var j = 0; j < this.contacts.length; j++) {
          if (this.contacts[j].IsSelected == true) {
            const selectObj = {
              MemberId: this.contacts[j].UserContactId,
              MemberName: this.contacts[j].UserName
            }
            this.selectedContactItem.push(selectObj)
          }
        }
      },

    },

  }
</script>
